// @ts-nocheck - Legacy file with extensive type issues requiring comprehensive refactoring (TODO: GXM-XXXX)
import { useEffect, useMemo, useState, useRef } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import API_ROUTES from "../../api-routes";
import apiService from "../../services/service";
import { z } from "zod";

const useShareholderForm = ({ type, setShowDialog, regData, resetRegData }) => {
  const [showShareHolderRegistration, setShowShareHolderRegistration] =
    useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [btnToggle, setBtnToggle] = useState(true);
  const [formDetails, setFormDetails] = useState({});
  const [isCongrats, setIsCongrats] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([]);

  const { shareholderId: id, entityId } = useParams<{
    shareholderId: string;
    entityId: string;
  }>();
  const navigate = useNavigate();

  useEffect(() => {
    setActiveIndex(0);
  }, []);

  const handleBack = () => {
    setActiveIndex((prevActiveStep) => Math.max(prevActiveStep - 1, 0));
  };

  const handleOfficerClick = () => {
    setShowShareHolderRegistration(true);
  };

  const handleOfficerSubmit = async () => {
    setIsLoading(true);
    if (regData) {
      const officerData = {
        name: regData.name || "",
        other_name: regData.other_name || "",
        last_name: regData.last_name || "",
        preferred_name: regData.preferred_name || "",
        role: regData.role.name || "",
        title: regData.title || "",
        email: regData.email || "",
        country: regData.country.code || "",
        phone_code: regData.phone_code || "",
        phone: regData.phone || "",
        type,
        expiration_date: regData.expiration_date || null,
        acting_as: regData.acting_as.name || null,
      };

      const apiRoute = API_ROUTES.ADD_OFFICER;
      try {
        const formData = new FormData();
        const fileOutput = [];
        for (let i = 0; i < files.length; i++) {
          const file = files[i]?.file;
          formData.append("file", file);
          let fileData = {
            fileName: file?.fileName,
            category: file?.category,
            subcategory: file?.subcategory,
          };
          if (file?.description) {
            fileData.description = file?.description;
          }
          fileOutput.push(fileData);
        }

        formData.append("officer", JSON.stringify(officerData));
        formData.append("filesData", JSON.stringify(fileOutput));

        const res = await apiService(apiRoute, "POST", {
          body: formData,
          replace: { id },
          schema: z.object({
            id: z.string(),
          }),
        });
        if (res.status) {
          resetRegData();
          setShowDialog(false);
          setFiles([]);
          setIsCongrats(true);
        } else {
          console.log("Not getting response");
        }
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (typeof resetRegData === "function") {
      resetRegData();
    }
  }, [navigate]);

  const checkValue = (data) =>
    Object.values(data).some((val) =>
      val && typeof val === "object"
        ? checkValue(val)
        : val !== "" && val !== false && val !== null,
    );

  const handleDialogToggle = () => {
    if (regData) {
      const hasValue = checkValue(regData);
      setShowDialog(hasValue);
    }
  };

  useEffect(() => {
    handleDialogToggle();
  }, [regData]);
  return {
    handleOfficerClick,
    showShareHolderRegistration,
    handleBack,
    activeIndex,
    setActiveIndex,
    entityId: id,
    btnToggle,
    setBtnToggle,
    formDetails,
    setFormDetails,
    isCongrats,
    setIsCongrats,
    isLoading,
    setIsLoading,
    handleOfficerSubmit,
    files,
    setFiles,
  };
};

export default useShareholderForm;
